import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';

import { ORDER_TYPE } from 'khufu-legos';
import { Button, Col, Container, Form, Nav, ProgressBar, Row } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Option } from 'react-bootstrap-typeahead/types/types';

import { Customer } from '../../../types';

interface StepOneParams {
  activeStep: number;
  handleCustomerChange: (option: Option[]) => void;
  customers: Customer[] | undefined;
  selectedCustomer: Option[];
  setActiveStep: (value: React.SetStateAction<number>) => void;
  orderType: ORDER_TYPE;
  setOrderType: (orderType: ORDER_TYPE) => void;
}

type FormControlElement = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;

const StepOne = ({
  activeStep,
  handleCustomerChange,
  customers,
  selectedCustomer,
  setActiveStep,
  orderType,
  setOrderType
}: StepOneParams) => {
  const handleOrderTypeChange: React.ChangeEventHandler<FormControlElement> = event => {
    const value = event.currentTarget.value as ORDER_TYPE;
    setOrderType(value);
  };

  return (
    <div className="main-content">
      <Container fluid>
        <Row className="justify-content-center">
          <Col xs={12} lg={10} xl={10} className="py-6">
            <Row className="justify-content-center">
              <Col xs={12} md={10} lg={8} xl={6} className="text-center">
                <h6 className="mb-4 text-uppercase text-muted">Step {activeStep} of 3</h6>
                <Col>
                  <ProgressBar variant="primary" now={33} className="progress-sm" />
                </Col>
                <h1 className="my-4">Get customer</h1>
                <p className="mb-5 text-muted">Search for the customer by name</p>
              </Col>
            </Row>
            <div className="form-group">
              <Form.Label>Customer name</Form.Label>
              <Typeahead
                id="customer-search"
                // onInputChange={handleInputChange}
                onChange={handleCustomerChange}
                placeholder="Select a customer..."
                // options={filteredCustomers}
                options={customers ?? []}
                labelKey="name"
                minLength={2}
              />
            </div>
            {selectedCustomer.length > 0 && (
              <div className="form-group">
                <Form.Label>Order Type</Form.Label>
                <Form.Control as="select" value={orderType} onChange={handleOrderTypeChange}>
                  <option value="express">Express</option>
                  <option value="delivery">Delivery</option>
                  <option value="MDP">MDP</option>
                  <option value="expiringGoods">Expiring Goods</option>
                  <option value="emptiesBuyback">Empties Buyback</option>
                </Form.Control>
              </div>
            )}
            {selectedCustomer.length > 0 && (
              <Nav className="row align-items-end justify-content-center">
                <Col xs="auto">
                  <Button
                    size="lg"
                    onClick={() => {
                      setActiveStep(activeStep + 1);
                    }}
                  >
                    Continue
                  </Button>
                </Col>
              </Nav>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default StepOne;
